exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app {\n  width: 100%;\n  height: 100%;\n  background: #f9f9f9;\n}\n\n/*# sourceMappingURL=src/app.css.map */", "", {"version":3,"sources":["/var/jenkins_home/workspace/payment-weixin-sdxbf-image/src/app.vue"],"names":[],"mappings":";AAAA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;CACrB;;AAED,uCAAuC","file":"app.vue","sourcesContent":["#app {\n  width: 100%;\n  height: 100%;\n  background: #f9f9f9;\n}\n\n/*# sourceMappingURL=src/app.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ef48958","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":75,"baseDpr":1}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app.vue
// module id = hNSM
// module chunks = 169